import Description from "./Description";
import InventoryPrice from "./InventoryPrice";
import ProductGallery from "./ProductGallery";
import ProductInfo from "./ProductInfo";
import ProductTab from "./ProductTab";
import Review from "./Review";

export {
  Description,
  InventoryPrice,
  ProductGallery,
  ProductInfo,
  ProductTab,
  Review,
};
